    <h1>Post OPD <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
    <div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
    <div class="row" *ngIf="dataLoaded">
        <div class="col-sm-8 border-right">
        <form [formGroup]="OpdForm" (submit)="updateOpd()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" formControlName="patient_name" class="form-control" />
                        <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                            <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                        </div>
                        <div *ngIf="(f.patient_name.value=='NA' || f.patient_name.value=='N/A') && invalidName" class="invalid-feedback">
                            <div>Please enter valid name</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" class="form-control readOnly" value="XXXXXXXXXX"/>
                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">Patient Mobile is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Patient Age</label>
                        <input type="number" formControlName="patient_age" class="form-control" />
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Gender</label>
                        <mat-select placeholder="Gender" formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label" >Select Doctor *</label>
                        <mat-select placeholder="Select Doctor" formControlName="doctor_id" (click)="setSearchValue('doctor')">
                            <input class="mySearchInput"
                            #doctorSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'doctor')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="doctorSearch">
                            <mat-option value="">Select Doctor</mat-option>
                            <mat-option [value]="doctor.id" *ngFor="let doctor of doctors">{{doctor.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.doctor_id.errors" class="invalid-feedback">
                            <div *ngIf="f.doctor_id.errors.required">Doctor is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Select Hospital *</label>
                        <mat-select placeholder="Select Hospital" formControlName="hospital_id" (click)="setSearchValue('hospital')">
                            <input class="mySearchInput"
                            #hospitalSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'hospital')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="hospitalSearch">
                            <mat-option value="">Select Hospital</mat-option>
                            <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.hospital_id.errors" class="invalid-feedback">
                            <div *ngIf="f.hospital_id.errors.required">Hospital is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Treatment *</label>
                        <mat-select placeholder="Select Treatment" formControlName="treatment_id" (click)="setSearchValue('treatment')">
                            <input class="mySearchInput"
                            #treatmentSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentSearch">
                            <mat-option value="">Select Treatment</mat-option>
                            <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                            <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                        </div>
                        <div *ngIf="f.treatment_id.value=='37' && invalidTreatment" class="invalid-feedback">
                            <div>Please select valid treatment</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Select BD *</label>
                        <mat-select placeholder="Select BD" [ngClass]="{'readOnly':myrole!='1'}" formControlName="user_id" (click)="setSearchValue('lead_owner')">
                            <input class="mySearchInput"
                            #ownerSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="ownerSearch">
                            <mat-option value="">Select BD</mat-option>
                            <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">BD is required</div>
                        </div>
                        <div *ngIf="f.user_id.value=='21' && invalidBd" class="invalid-feedback">
                            <div>Please select valid BD</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Appointment Date *</label>
                        <mat-form-field appearance="fill">
                            <mat-label>Choose a date</mat-label>
                            <input matInput readonly formControlName="appointment_date" [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.appointment_date.errors" class="invalid-feedback">
                            <div *ngIf="f.appointment_date.errors.required">Appointment Date is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Appointment Time *</label>
                        <input type="time" formControlName="appointment_time" class="form-control" />
                        <div *ngIf="submitted && f.appointment_time.errors" class="invalid-feedback">
                            <div *ngIf="f.appointment_time.errors.required">Appointment Time is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Consultation Type</label>
                        <mat-select placeholder="Consultation Type" formControlName="consultation_type">
                            <mat-option>Select Consultation Type</mat-option>
                            <mat-option [value]="1">Online Consultation</mat-option>
                            <mat-option [value]="2">Offline Consultation</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Consultation Fee *</label>
                        <input type="text" formControlName="consultation_fee" class="form-control" />
                        <div *ngIf="submitted && f.consultation_fee.errors" class="invalid-feedback">
                            <div *ngIf="f.consultation_fee.errors.required">Consultation Fee is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6" *ngIf="myrole==1">
                        <label class="form-label">Doctor Share</label>
                        <input type="text" class="form-control" formControlName="doctor_share" />
                        <div *ngIf="submitted && f.doctor_share.errors" class="invalid-feedback">
                            <div *ngIf="f.doctor_share.errors.required">Doctor Share is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group"  *ngIf="myrole==1">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Hospital Share</label>
                        <input type="text" class="form-control" formControlName="hospital_share" />
                        <div *ngIf="submitted && f.hospital_share.errors" class="invalid-feedback">
                            <div *ngIf="f.hospital_share.errors.required">Hospital Share is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Glamyo Share</label>
                        <input type="text" class="form-control" formControlName="glamyo_share" />
                        <div *ngIf="submitted && f.glamyo_share.errors" class="invalid-feedback">
                            <div *ngIf="f.glamyo_share.errors.required">Glamyo Share is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Surgery Suggested</label>
                        <mat-select placeholder="Surgery Suggested" formControlName="surgery_suggested">
                            <!-- [ngClass]="{'readOnly': myrole!= 1 && prescriptionStatus==0}" -->
                            <mat-option [value]="0">Pending</mat-option>
                            <mat-option [value]="1">Yes</mat-option>
                            <mat-option [value]="2">No</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.surgery_suggested.errors" class="invalid-feedback">
                            <div *ngIf="f.surgery_suggested.errors.required">Surgery Suggested is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6" *ngIf="f.surgery_suggested.value==1">
                        <label class="form-label">Follow Up Date</label>
                        <mat-form-field appearance="fill">
                            <mat-label>Choose a date</mat-label>
                            <input matInput readonly formControlName="followup_date" [matDatepicker]="picker2">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.followup_date.errors" class="invalid-feedback">
                            <div *ngIf="f.followup_date.errors.required">Followup Date is required</div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">

                    </div>
                    <div class="col-sm-6 notediv" *ngIf="myrole!= 1 && myrole!=4">
                        For mark completed Opd. Please upload required documents and coordinate with medical officer or city BD.
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Upload Prescription</label>
                        <input type="file" (change)="selectPrescription($event)" class="form-control" />
                        <div *ngIf="submitted && f.prescription.errors" class="invalid-feedback">
                            <div *ngIf="f.prescription.errors.required">Prescription is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Select Status *</label>
                        <mat-select placeholder="Select Status" formControlName="status">
                            <!-- [ngClass]="{'readOnly': myrole!= 1 && myrole!=4 && myrole!=3}" -->
                            <mat-option value="">Select Status</mat-option>
                            <mat-option [value]="0">Active</mat-option>
                            <mat-option [value]="1">Completed</mat-option>
                            <mat-option [value]="3">Cancel</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                            <div *ngIf="f.user_id.errors.required">Status is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group margintp20">
                <div class="row bordercss">
                    <label class="form-label">Medical Officer Action</label>
                 </div>
                 <div class="row margintp20">
                    <div class="col-sm-6">
                        <label class="form-label">Select Action</label>
                        <mat-select placeholder="Select Action" formControlName="approved_status" [ngClass]="{'readOnly': myrole!= 1 && myrole!=4}">
                            <mat-option value="">Select Status</mat-option>
                            <mat-option [value]="1">Approved</mat-option>
                            <mat-option [value]="2">Rejected</mat-option>
                            <mat-option [value]="3">Approved with High Risk</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="form-label">Comments</label>
                            <textarea class="form-control" formControlName="comments" [ngClass]="{'readOnly': myrole!= 1 && myrole!=4}"></textarea>
                        </div>
                    </div>
                 </div>
            </div>
            <input type="hidden" formControlName="mobile" class="form-control" />


            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
            </div>
            </form>
        </div>
        <div class="col-sm-4" *ngIf="opdChk">
            <h2>Upload Case Papers</h2>
            <div class="form-group">
                <label>Upload Documents</label>
                <input type="file" (change)="selectFile($event)" class="form-control" />
                <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>

            <div class="list-group list-group-flush list-group-hoverable">
                <p *ngIf="fileDeleting"><i class="fa fa-spin fa-spinner"></i> deleting file...</p>
                <div class="list-group-item" *ngFor="let upload of allUploads">
                    <div class="row align-items-center">
                        <div class="col text-truncate">
                            <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>

                            <a *ngIf="myrole=='1' || myrole=='4'" class="delete-file" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                            confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true"><i class="fa fa-trash"></i></a>

                            <!-- <span (click)="openOpdDocsStatusDialog(upload)"><i class="fa fa-pen editIcon"></i></span>  -->

                            <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Prescription</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==2'>Case Paper</span>
                            <!-- <span [ngClass]="{'btn-success': upload.approved_status == 1, 'btn-danger' : upload.approved_status == 2, 'btn-warning' : upload.approved_status == 3, 'btn-info' : upload.approved_status == 4 }" class="statuslink" *ngIf="upload.approved_status">{{getApprovedStatus(upload.approved_status)}}</span> -->

                            <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
